import { render } from "./Index.vue?vue&type=template&id=5f4512ef&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5f4512ef&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=5f4512ef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4512ef"]])

export default __exports__